import posthog from "posthog-js";
import { wireGlobalErrorListeners } from "@soprisapps/components/utils/errorReporting";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  debug: process.env.NEXT_PUBLIC_APP_ENV === "dev",
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  person_profiles: "identified_only",
  disable_session_recording: false,
  // sample_rate '0' suppresses recording by default; reportError calls
  // startSessionRecording({sampling: true}) so only error sessions are kept.
  session_recording: {
    maskAllInputs: true,
    sample_rate: "0",
  },
});

posthog.register({
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  app_context: process.env.NEXT_PUBLIC_APP_CTX,
  hostname:
    typeof window !== "undefined" ? window.location.hostname : undefined,
  code_version: process.env.NEXT_PUBLIC_REACT_FRONTEND_VERSION,
});

wireGlobalErrorListeners();
